<template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title>
                    <div class="headline">Prepare Job</div>
                </v-card-title>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 d-flex>
                            <router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig" :existingData="{}"></router-view>
                        </v-flex>
                        <!--<v-flex xs12 class="text-xs-center">-->
                            <!--<router-link :to="{name: 'dataops'}">Import/Export Dashboard</router-link>-->
                        <!--</v-flex>-->
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'DataOpsSetup',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
